import React from 'react';
import { ExternalLink, TextView } from '@ygtechnologies/bygr-frontend-component-library';
import { ObjectHistoryLog } from '@/types';
import theme from './AcceptedTermsTooltip.module.scss';
import { Trans } from '@lingui/react/macro';

interface AcceptedTermsToolTipProps {
    parametersJson: ObjectHistoryLog['parametersJson'];
}
const AcceptedTermsContent = ({ parametersJson }: AcceptedTermsToolTipProps) => {
    return (
        <TextView numberOfLines={0}>
            <div className={theme.titleAndDescription} lang="en">
                <span className={theme.title}>
                    <Trans>Terms and conditions</Trans>
                </span>
                {parametersJson['termsAndConditions']}
            </div>

            <div className={theme.titleAndDescription} lang="en">
                <span className={theme.title}>
                    <Trans>Privacy policy</Trans>
                </span>
                <ExternalLink href={parametersJson['privacyPolicyUrl']} target="_blank">
                    {parametersJson['privacyPolicyUrl']}
                </ExternalLink>
            </div>
        </TextView>
    );
};

export const AcceptedTermsTooltip = ({ parametersJson }: AcceptedTermsToolTipProps) => {
    return (
        <div className={theme.container}>
            <Trans>User accepted terms and conditions</Trans>
            <AcceptedTermsContent parametersJson={parametersJson} />
        </div>
    );
};
